<template>
  <div class="wrapper" v-if="advertList.length > 0">
    <el-carousel height="156px">
      <el-carousel-item v-for="(v,i) in advertList" :key="i">
        <el-image :src="v.image" @click="openUrl(v)"></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "Advert",
  data() {
    return {
      advertList: []
    }
  },
  created() {
    this.$request.get('/Home/advert').then(res => {
      if (res.code === 0) {
        this.advertList = res.data
      }
    })
  },
  methods: {
    /**
     * 打开外链
     * @param url
     */
    openUrl({url}) {
      window.open(url, '_blank')
    }
  }
}
</script>


<style scoped lang="scss">
.wrapper {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}
</style>